import React, { useState, useEffect } from 'react';
import './Loader.scss';
import { CircularProgress } from '@mui/material';
import { useAppContext } from '../../provider/AppContextProvider';
import { useGlobalContext } from '../../provider/GlobalContextProvider';

function Loader() {
  const { loader } = useAppContext();
  const { gloader } = useGlobalContext();
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const hasActiveLoaders = (loader && loader.length > 0) || (gloader && gloader.length > 0);
    
    if (hasActiveLoaders) {
      setShowLoader(true);
    } else {
      // When both loaders become empty, wait 1 second before hiding
      const timer = setTimeout(() => {
        setShowLoader(false);
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, [loader, gloader]);

  // console.log("Loader state - showLoader:", showLoader, "loader:", loader, "gloader:", gloader, "current time:", new Date().toISOString());

  return (
    <>
      {showLoader &&
        <div className="loader-container" data-testid="loaderTestId">
          <CircularProgress  />
        </div>
      }
    </>
  );
};
export default Loader;